function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "23.334",
  height: "21.933",
  xmlns: "http://www.w3.org/2000/svg",
  strokeWidth: "2",
  stroke: "currentColor",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.604 12.471S3.35 5.57 6.063 3.656c2.713-1.914 4.369 6.092 4.369 6.092s-3.04-8.605-.061-9.06c2.979-.457 3.902 7.85 3.902 7.85S12.09-.252 15.556.475c3.467.727 2.154 8.266 2.154 8.266s.16-7.611 2.61-6.94c2.452.673 2.177 8.009 2.2 8.228.023.22 1.64 8.7-1.982 10.136s-8.54 1.33-8.54 1.33l-7.41-5.018S-1.066 14.43.805 11.472c1.606-2.538 6.798 1 6.798 1z"
})));